import {createContext} from 'react';
import _ from 'underscore';

const THEME_RED = 'red';
const THEME_PINK = 'pink';
const THEME_PURPLE = 'purple';
const THEME_DEEP_PURPLE = 'deep_purple';
const THEME_INDIGO = 'indigo';
const THEME_BLUE = 'blue';
const THEME_LIGHT_BLUE = 'light_blue';
const THEME_CYAN = 'cyan';
const THEME_TEAL = 'teal';
const THEME_GREEN = 'green';
const THEME_LIGHT_GREEN = 'light_green';
const THEME_LIME = 'lime';
const THEME_YELLOW = 'yellow';
const THEME_AMBER = 'amber';
const THEME_ORANGE = 'orange';
const THEME_DEEP_ORANGE = 'deep_orange';

export const DEFAULT_THEME = THEME_RED;

export const THEMES = [
    THEME_RED,
    THEME_PINK,
    THEME_PURPLE,
    THEME_DEEP_PURPLE,
    THEME_INDIGO,
    THEME_BLUE,
    THEME_LIGHT_BLUE,
    THEME_CYAN,
    THEME_TEAL,
    THEME_GREEN,
    THEME_LIGHT_GREEN,
    THEME_LIME,
    THEME_YELLOW,
    THEME_AMBER,
    THEME_ORANGE,
    THEME_DEEP_ORANGE
];


// MDL (Material Design Lite) was deprecated by Google - CSS CDN returns 403
// Themes are now handled via CSS custom properties in our own stylesheets
// This function is kept for backwards compatibility but does nothing
export const attachCssForTheme = function(theme) {
    // No-op: MDL CSS no longer needed, themes handled via getThemeClassName()
};

export const getThemeClassName = (theme) => {
    let themeKey = _(THEMES).contains(theme)
        ? theme
        : DEFAULT_THEME;

    return `al_${themeKey}-theme`;
}

export const ThemeContext = createContext(DEFAULT_THEME);
